import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { catchError, NEVER, throwError } from 'rxjs'
import { env } from '../../environments/environment'
import { gewaehltesHaus, HAUS_ABGELEHNT_HEADER, HAUS_HEADER, merkeHaus } from './haus-wahl'

/**
 * Schickt das gewaehlte Haus an jeden Aufruf des Portal-Backends (Haus-Wechsel).
 *
 * Lehnt das Backend die Wahl ab (403 mit `X-Haus-Abgelehnt`: das Konto wurde dort entfernt, oder die
 * Wahl stammt aus einem anderen Konto auf diesem Rechner), verwirft das Portal sie und laedt im
 * Heimat-Haus neu. Der fehlgeschlagene Aufruf endet dabei nie: der Neustart folgt sofort, und eine
 * Fehlermeldung davor wuerde nur einen Zustand melden, den es gleich nicht mehr gibt.
 */
export const hausWahlInterceptor: HttpInterceptorFn = (req, next) => {
  // Aus der Umgebung statt ueber ENV_TOKEN: der haengt an app.config, und die importiert diesen Interceptor.
  const backend = env().api.leistungserbringerUrl
  const haus = req.url.startsWith(backend) ? gewaehltesHaus() : null
  const anfrage = haus ? req.clone({ setHeaders: { [HAUS_HEADER]: haus } }) : req
  return next(anfrage).pipe(
    catchError((fehler: unknown) => {
      if (haus && fehler instanceof HttpErrorResponse && fehler.status === 403 && fehler.headers.get(HAUS_ABGELEHNT_HEADER)) {
        merkeHaus(null)
        window.location.assign('/')
        return NEVER
      }
      return throwError(() => fehler)
    }),
  )
}
